export enum Theme {
  PM = 'pm',
  FitLine = 'fitline',
}
